import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createJob } from '../api';
import { useToast } from '@/components/ToastProvider';
import { ApiError } from '@/lib/api';

export function useCreateJob() {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: createJob,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
      toast.success('Job created successfully');
    },
    onError: (error: Error) => {
      const message = error instanceof ApiError ? error.message : 'Failed to create job';
      toast.error(message);
    },
  });
}
